import cx from "classnames";

import CS from "metabase/css/core/index.css";
import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

import MetrioniQLogo from "./maven-analytics.png";

interface LogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

// MetrioniQ: render the brand mark instead of upstream's inline Metabase logo.
// The image is kept in sync by bin/rebrand (branding/assets/).
export const DefaultLogoIcon = ({ dark, height = 32, width }: LogoIconProps) => {
  return (
    <img
      src={MetrioniQLogo}
      className={cx(
        "Icon",
        { [CS.textMetabaseBrand]: !dark },
        { [CS.textWhite]: dark },
      )}
      width={width}
      height={height}
      data-testid="main-logo"
      alt="MetrioniQ"
    />
  );
};

export function LogoIcon(props: LogoIconProps) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
